<template>

	<v-list dense>
      <v-subheader> {{ 'Lessons' | t }} </v-subheader>
      <v-list-item-group
        color="primary"
      >
        <v-list-item
          v-for="(lesson, i) in lesson_list"
          :key="i"
          router :to="'/textbook/' + lesson.route"
        >
          <v-list-item-content>
            <v-list-item-title v-text="lesson.name"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

</template>

<script>

export default {
  props: ['lesson_list'],
	components: {},
	data() {
		return {

		}
	},
	methods: {

	},
	created() {

	}
}
</script>
